import styled from "styled-components";
import Variables from "../../assets/styleVariables";
import {EXPANDED_SIDEBAR_WIDTH, HEADER_BAR_HEIGHT} from "../../constants/fixedStyleVariables";

export const ToolsWrapper = styled.div`
	display: flex;
	height: calc(100vh - ${HEADER_BAR_HEIGHT}px);
	margin-top: ${HEADER_BAR_HEIGHT}px;	
`;	

export const ToolsBody = styled.div`
	flex: 1;	
	background-color: ${Variables.colors.complementary};
	max-height: calc(100vh - ${HEADER_BAR_HEIGHT}px);
	overflow-y: auto;  
	margin-right: ${props => props.noSidebar ? 0 : EXPANDED_SIDEBAR_WIDTH +'px'};	
`;

export const ToolsContainer = styled.div`	
	width: 100%;	
	min-height: calc(100vh - 100px);
	height: auto;
	overflow-x: auto;
	overflow-y: hidden;
`;